import { getAccessToken } from '@/utils/plugins/jwt'
import { Route } from 'vue-router'
import Store from '@/lib/store'

export const routerBeforeEach = async (to: Route, from: Route, next: any) => {
  if (to.meta?.guard) {
    const token = getAccessToken()
    if (!token) {
      next({ name: 'auth.signIn' })
    }
  }
  Store.commit('setRouteFrom', from)
  next()
}
